module.exports = __webpack_public_path__ + "static/media/img-collabo-01@3x.b9331466.webp";